import type { SVGProps } from 'react';

const ZoomInIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17.75 17.75" fill="none" {...props}>
    <path
      d="M17 17L13.1265 13.1265M13.1265 13.1265C14.4385 11.8145 15.25 10.002 15.25 8C15.25 3.99594 12.0041 0.75 8 0.75C3.99594 0.75 0.75 3.99594 0.75 8C0.75 12.0041 3.99594 15.25 8 15.25C10.002 15.25 11.8145 14.4385 13.1265 13.1265ZM8 4.75V11.25M11.25 8L4.75 8"
      stroke="#292A33"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ZoomInIcon;
